import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { DEFAULT_PAGE_PROMOTION_SESSION_KEY } from 'components/PagePromotion/PagePromotionCta';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { isBlank } from 'helpers/verify';
import { readSessionStorage } from 'redux/saga/helpers/local-storage';
import { BaseCtaWithLink } from './BaseCtaWithLink';

export class JoinCta extends Component {
  state = {
    sessionPromotionAlias: null,
  };

  componentDidMount() {
    const sessionPromotionAlias = readSessionStorage(DEFAULT_PAGE_PROMOTION_SESSION_KEY, null, true);
    if (!isBlank(sessionPromotionAlias)) {
      this.setState({ sessionPromotionAlias });
    }
  }

  render() {
    const { schedule, className, children, ...props } = this.props;
    const { sessionPromotionAlias } = this.state;

    return (
      <BaseCtaWithLink
        className={classNames(className, 'bt--primary')}
        {...props}
        to={`/pricing/${sessionPromotionAlias || GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS}`}
        onClick={() => {
          segment.track('Venue Details', {
            action: 'Schedule Join Click',
            label: schedule.id,
          });
          ga('Venue Details', 'Schedule Join Click', schedule.id);
        }}>
        {children || <FormattedMessage id="schedule.row.cta-join" defaultMessage="Join" />}
      </BaseCtaWithLink>
    );
  }
}

JoinCta.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  schedule: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }),
};
